import { render } from "./GroupSurveyPage.vue?vue&type=template&id=383260f7&scoped=true"
import script from "./GroupSurveyPage.vue?vue&type=script&lang=js"
export * from "./GroupSurveyPage.vue?vue&type=script&lang=js"

import "./GroupSurveyPage.vue?vue&type=style&index=0&id=383260f7&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-383260f7"]])

export default __exports__